// extracted by mini-css-extract-plugin
export default {"bookrack":"index_bookrack_-0ijj","bookrackImg":"index_bookrackImg_lQycR"};